import React from "react";
import NotFoundDesign from "../../UIcomponent/Icon/NotFound";
import { Layout } from "./styles";
import Metas from "../../Component/Metas";
import { Button } from "@material-ui/core";
const NotFound = () => {
  return (
    <Layout
      style={{
        marginTop: "70px",
        flexDirection: "column",
      }}
    >
      <Metas
        noIndex={true}
        title="Page Not Found"
        description="صفحه مورد نظر پیدا نشد"
      />
      <NotFoundDesign />
      <br />
      <a href="/">
        <Button variant="outlined" color="primary">
          بازگشت به صفحه اصلی
        </Button>
      </a>
    </Layout>
  );
};

export default NotFound;
